import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

const data = [
  { name: 'Lun', contactos: 12 },
  { name: 'Mar', contactos: 19 },
  { name: 'Mié', contactos: 15 },
  { name: 'Jue', contactos: 22 },
  { name: 'Vie', contactos: 18 },
  { name: 'Sáb', contactos: 9 },
  { name: 'Dom', contactos: 7 },
];

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="p-2 bg-white border rounded shadow-md">
        <p className="font-bold">{`${label}`}</p>
        <p className="text-blue-600">{`Contactos: ${payload[0].value}`}</p>
      </div>
    );
  }
  return null;
};

export const ContactsChart: React.FC = () => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="name" tickLine={false} axisLine={false} tick={{fill: '#6b7280'}} />
        <YAxis tickLine={false} axisLine={false} tick={{fill: '#6b7280'}} allowDecimals={false} />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(239, 246, 255, 0.5)' }}/>
        <Bar dataKey="contactos" fill="#3b82f6" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};